import { gql } from 'graphql-tag'

export default gql`
  fragment EventAgendaSectionItemFragment on EventAgendaSectionItem {
    sys {
      id
    }
    contentType: __typename
    time
    title
    speaker
    description {
      json
    }
  }
`
